import { render, staticRenderFns } from "./modex-2026-banner.vue?vue&type=template&id=bc33f104&scoped=true&"
import script from "./modex-2026-banner.vue?vue&type=script&lang=js&"
export * from "./modex-2026-banner.vue?vue&type=script&lang=js&"
import style0 from "./modex-2026-banner.vue?vue&type=style&index=0&id=bc33f104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc33f104",
  null
  
)

export default component.exports